export function NoInternetScreen() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white px-6">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center">
          <img src="/WifiOff.svg" alt="Sin conexión" className="w-8 h-8 opacity-40 grayscale" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">
          Sin conexión a internet
        </h1>
        <p className="text-gray-500 text-sm">
          Revisa tu conexión e inténtalo de nuevo.
        </p>
      </div>
    </div>
  );
}
